import React from 'react'
import './Chat.css'
import { Avatar } from '@material-ui/core'
import { NavLink, Link } from 'react-router-dom'

const Chat = ({ name, message, timestamp, profilePic }) => {
    return (
        <NavLink to={`/chat/${name}`}>
            <div className='chat'>
                <Avatar className='chat__image' src={profilePic} />
                <div className='chat__details'>
                    <h2>{name}</h2>
                    <p>{message}</p>
                </div>
                <p className='chat__timestamp'>{timestamp}</p>
            </div>
        </NavLink>
    )
}

export default Chat